import {batch} from 'react-redux';

import {updateLoading} from '@/actions/loadingActions';
import {getStateServerAlive} from '@/api/configApi';
import {postRestartService} from '@/api/serviceSoftwareApi';
import {TIME_OUT_REFRESH, URL_HOST} from '@/constants/constant';
import {formatMessage} from '@/libs/intlHelper';

import {ViewMode} from '../../constants/dataEnum';
import {changeView} from '../actions/appStateAction';
import globalReduxStore, {dispatch} from '../globalReduxStore';

// Max attempts to reconnect: 10 mins.
export const tryGetServerAlive = (attemptsLeft = 400, interval = 3000) =>
  new Promise((resolve, reject) => {
    getStateServerAlive()
      .then(() => {
        setTimeout(() => {
          window.location.reload();
          resolve();
        }, 800);
      })
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);

            return;
          }
          // Try to reload components.
          tryGetServerAlive(attemptsLeft - 1).then(resolve, reject);
        }, interval);
      });
  });

export function disbandRefresh() {
  const {appState, signalRState} = globalReduxStore.getState(['appState', 'signalRState']);
  const {viewMode} = appState;
  const {sessionIsTakenOver} = signalRState;

  return viewMode === ViewMode.LOGIN || sessionIsTakenOver;
}

export const handleChangePage = (view) => (dispatch) => {
  // const state = getState();
  // const {openLoginPage, openNotificationPage} = state.appState;

  batch(() => {
    dispatch(changeView(view));
    // if (openLoginPage) dispatch(setOpenLoginPage(false));
    // if (openNotificationPage) dispatch(setOpenNotificationPage(false));
  });
};

export const refreshBrowser = () => {
  setTimeout(() => {
    window.location.replace(URL_HOST);
  }, TIME_OUT_REFRESH);
};

export const restartSystem = () => async () => {
  try {
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: formatMessage({id: 'loading.refreshing.message'}),
      }),
    );
    await postRestartService();
    refreshBrowser();
  } catch (error) {
    console.log('restartSystem error', error);
  }
};
